// extracted by mini-css-extract-plugin
module.exports = {"label":"File_label__D0Cs0","tooltip":"File_tooltip__2QZBm","wrap":"File_wrap__3f_qs","input":"File_input__2u3oe","box":"File_box__39nHw"};